module.exports = __webpack_public_path__ + "img/Folded_Paper_case_thumbnail_Team_Changing_Academy.72b4eb34.jpg";